import { LoaderCircle } from 'lucide-react';

export function SectionLoader(): React.ReactElement {
  return (
    <div className="flex items-center justify-center py-10 text-muted-foreground">
      <LoaderCircle size={20} className="animate-spin" />
    </div>
  );
}
